<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <div class="iqos-tooltip-helper-box mr-8">
          <BaseButton
            variant="primary"
            bold
            color="orange-4"
            icon="qr-code"
            @click="show_test_qr_code = !show_test_qr_code"
            size="md"
          >
            {{ $t("inside.test_button") }}
          </BaseButton>

          <IQOSTooltip
            :title="$t('inside.test_button')"
            earPosition="top-right"
            size="sm"
            :qrLink="testOrderLink"
            @close="show_test_qr_code = false"
            v-if="show_test_qr_code"
          >
            <div style="text-align: center;">
              {{ $t("inside.test_tooltip") }}
            </div>
          </IQOSTooltip>
        </div>
        <BaseButton
          @click="$router.push({
            name: 'subscription_history',
            query: {
              from: 'delivery'
            }
          })"
          color="v1-grey-10"
          variant="secondary"
          size="md"
        >{{ $t("tables.payments_history") }}</BaseButton>
      </template>
    </Header>

    <PageContainer>
      <!-- <StoreCard :mode="isProUser ? 'pro' : 'delivery'" /> -->
      <SystemCard :mode="'delivery'" />

      <div
        class="qrw-heading-md mb-24 mt-40"
        :class="{
        'system-settings-disabled': !isEnabled
      }"
      >
        {{ $t("mode_settings.required") }}
      </div>

      <div
        class="iqos-grid"
        :class="{'system-settings-disabled': !isSystemAvailableInBillingPlan || !isEnabled}"
      >
        <div class="iqos-column">
          <PaymentCard :mode="'delivery'" />
          <GeolocationPanel v-if="!hideManualDelivery" />
          <SystemMotdPanel :mode="'delivery'" />
        </div>
        <div class="iqos-column">
          <TimingSettingsPanel :mode="'delivery'" />
          <PackageCost />
          <DeliveryPrice />
          <AutoCancelPanel :mode="'delivery'" />
        </div>
      </div>

      <div
        class="qrw-heading-md mb-24 mt-40 v1-grey-6-color"
        :class="{
        'system-settings-disabled': !isEnabled
      }"
      >
        {{ $t("mode_settings.optional") }}
      </div>

      <div
        class="iqos-grid"
        :class="{'system-settings-disabled': !isSystemAvailableInBillingPlan || !isEnabled}"
      >
        <div class="iqos-column">

          <MinCheckPanel />

          <div v-if="individualPricing">
            <DeliveryIndividualPrice :type="individualPricing" />
          </div>
        </div>
        <div class="iqos-column">
          <!-- <ModeScheduleEditor :mode="'delivery'" /> -->

          <GuestsCountFlagPanel />
          <DeliveryAddressDetails />
          <CourierReminderPanel />
          <DemoQRCodePanel :mode="'delivery'" />
        </div>
      </div>

      <!-- <MoecoPartnerBlock v-if="canShowMoeco" /> -->
    </PageContainer>
  </div>
</template>

<script>
import ModeScheduleEditor from '@/components/schedule/ModeScheduleEditor.vue'
import DeliveryPrice from '@/components/delivery/DeliveryPrice.vue'
import PaymentCard from '@/components/PaymentCard.vue'
import OrdersHistory from '@/components/OrdersHistory.vue'
import DeliveryPartnerPrice from '@/components/DeliveryPartnerPrice.vue'
import DeliveryIndividualPrice from '@/components/DeliveryIndividualPrice.vue'
import PackageCost from '@/components/PackageCost.vue'
import GeolocationPanel from '@/components/GeolocationPanel.vue'
import MinCheckPanel from '@/components/MinCheckPanel.vue'
import ContactPhonePanel from '@/components/ContactPhonePanel.vue'
import TimeLimit from '@/components/TimeLimit.vue'
import DeliveryAddressDetails from '@/components/delivery/DeliveryAddressDetails.vue'
import MoecoPartner from '@/components/delivery/MoecoPartner.vue'
import MoecoPartnerBlock from '@/components/delivery/MoecoPartnerBlock.vue'
import TaxiPricePanel from '@/components/delivery/TaxiPricePanel.vue'
import ServingFeeMode from '@/components/general/ServingFeeMode.vue'
import DeliveryShippingTime from '@/components/delivery/DeliveryShippingTime.vue'
import GuestsCountFlagPanel from '@/components/delivery/GuestsCountFlagPanel.vue'
import SystemMotdPanel from '@/components/SystemMotdPanel.vue'
import TimingSettingsPanel from '@/components/TimingSettingsPanel.vue'
import CourierReminderPanel from '@/components/delivery/CourierReminderPanel.vue'
import AutoCancelPanel from '@/components/general/AutoCancelPanel.vue'

import StoreCard from '@/components/subscriptions/StoreCard.vue'
import SystemCard from '@/components/superbilling/SystemCard.vue'

export default {
  data() {
    return {
      show_test_qr_code: false
    }
  },
  methods: {},
  computed: {
    deliveryPartner() {
      return this.$store.getters.deliveryPartner
    },
    hideManualDelivery() {
      if (!this.deliveryPartner) return false

      return this.$store.state.cafe.delivery.service_status == 'ready'
    },
    isSystemAvailableInBillingPlan() {
      return this.$store.getters['checkBillingPlanForPaidService']('delivery')
    },
    individualPricing() {
      const str_id = `${this.$store.state.cafe._id}`
      const individual_ids = {
        46: 'tenshi'
      }

      if (individual_ids[str_id]) return individual_ids[str_id]

      return null
    },
    canShowMoeco() {
      return this.$store.state.cafe.city == 'Ужгород' || this.$store.state.cafe.city == 'Чинадійово'
    },
    readyDelivery() {
      const from_store = Object.assign({}, this.$store.getters.readyDelivery)

      delete from_store.total
      delete from_store.subtotal

      return from_store
    },
    testOrderLink() {
      return this.$store.getters.onlineMenuLink('delivery')
    },
    isProUser() {
      return this.$store.getters['subscriptions/isProUser']
    },
    isEnabled() {
      return this.cafe.modes.delivery
    },
    cafe() {
      return this.$store.state.cafe
    }
  },
  components: {
    ModeScheduleEditor,
    DeliveryPrice,
    DeliveryPartnerPrice,
    PaymentCard,
    OrdersHistory,
    PackageCost,
    SystemMotdPanel,
    GeolocationPanel,
    MinCheckPanel,
    ContactPhonePanel,
    DeliveryIndividualPrice,
    TimeLimit,
    DeliveryAddressDetails,
    MoecoPartner,
    MoecoPartnerBlock,
    TaxiPricePanel,
    ServingFeeMode,
    DeliveryShippingTime,
    GuestsCountFlagPanel,
    TimingSettingsPanel,
    CourierReminderPanel,
    AutoCancelPanel,
    StoreCard,
    SystemCard
  }
}
</script>

<style scoped>
</style>
